module.exports = __webpack_public_path__ + "static/media/Ochsner&Associes.68dbc92b.png";